module.exports = __webpack_public_path__ + "img/CookieCrush_40.6db0bd7a.png";